function getUseLayerOptions(position) {
  const map = {
    "bottom-center": {
      placement: "bottom-center",
      possiblePlacements: ["bottom-center", "top-center"]
    },
    "bottom-left": {
      placement: "bottom-start",
      preferX: "left",
      preferY: "bottom",
      possiblePlacements: ["bottom-start", "top-start"]
    },
    "bottom-right": {
      placement: "bottom-end",
      preferX: "right",
      preferY: "bottom",
      possiblePlacements: ["bottom-end", "top-end"]
    },
    bottom: {
      placement: "bottom-start",
      preferX: "left",
      preferY: "bottom",
      possiblePlacements: ["bottom-start", "top-start"]
    },
    "top-left": {
      placement: "top-start",
      preferX: "left",
      preferY: "top",
      possiblePlacements: ["top-start", "bottom-start"]
    },
    "top-right": {
      placement: "top-end",
      preferX: "right",
      preferY: "top",
      possiblePlacements: ["top-end", "bottom-end"]
    },
    "right-center": {
      placement: "right-center",
      possiblePlacements: ["right-center"]
    },
    "left-center": {
      placement: "left-center",
      possiblePlacements: ["left-center"]
    }
  };
  return map[position];
}
export {
  getUseLayerOptions
};
//# sourceMappingURL=getUseLayerOptions2.js.map
